import { FLAGS_BASE_URL } from 'const/env'
import upperCase from 'lodash/upperCase'

export const getFlagUrl = (code) => `${FLAGS_BASE_URL}/${upperCase(code)}.svg`
